class TabComponent extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    // Select the tabs and content panes within the component's light DOM
    this.tabs = this.querySelectorAll('.product-tab');
    this.tabPanes = this.querySelectorAll('.product-tab-pane');

    // Add click event listeners to the tabs
    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => this.onTabClick(tab));
    });

    // Optionally activate the first tab
    if (this.tabs.length > 0) {
      this.tabs[0].classList.add('active');
      this.tabPanes[0].classList.add('active');
    }
  }

  onTabClick(tab) {
    const tabNumber = tab.dataset.tab;

    this.tabs.forEach((t) => t.classList.remove('active'));
    this.tabPanes.forEach((pane) => pane.classList.remove('active'));

    tab.classList.add('active');
    this.querySelector(`.product-tab-pane[data-tab-content="${tabNumber}"]`).classList.add('active');
  }
}

customElements.define('tab-component', TabComponent);
